var map = {
	"./doggo1.jpg": "fed1",
	"./doggo2.jpg": "92fa",
	"./doggo3.jpg": "a73e",
	"./kitty1.jpg": "d5f7",
	"./kitty2.jpg": "0121",
	"./kitty3.jpg": "5448"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";